import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import ITokenData from '@/models/auth/ITokenData';

export class LocalStorageUtils {
    /**
     * Gets the value for the given key. Attempts to JSON.parse() the value, returning an object when successful.
     * Otherwise returns the string or null.
     * @param key
     * @returns
     */
    get(key: string): string | null {
        if (this.hasKey(key)) {
            try {
                const parsed = JSON.parse(localStorage.getItem(key) || '{}');

                if (typeof parsed !== 'number') {
                    return parsed;
                } else {
                    return String(parsed);
                }
            } catch (e) {
                return localStorage.getItem(key);
            }
        } else {
            return null;
        }
    }

    hasKey(key: string): boolean {
        return localStorage.getItem(key) !== null;
    }

    hasKeyAndValue(key: string): boolean {
        if (!this.hasKey(key)) {
            return false;
        }

        const value = localStorage.getItem(key);
        return value ? true : false;
    }

    /**
     * Save the given value. If no value is provided will remove any existing value.
     * @param key
     * @param value
     */
    save(key: string, value: string | undefined): void {
        if (value) {
            localStorage.setItem(key, value);
        } else {
            localStorage.removeItem(key);
        }
    }

    remove(key: string): void {
        localStorage.removeItem(key);
    }

    saveTokenData(tokenData: ITokenData): void {
        this.save(LocalStorageKeys.qsAccessToken, JSON.stringify(tokenData.access_token));
        this.save(LocalStorageKeys.qsRefreshToken, JSON.stringify(tokenData.refresh_token));
        this.save(LocalStorageKeys.qsAccessTokenExpiration, JSON.stringify(tokenData.expires));
    }
}

const theLocalStorageUtils = new LocalStorageUtils();
export default theLocalStorageUtils;
